(function (_, kotlin_io_ktor_ktor_serialization_kotlinx, kotlin_io_ktor_ktor_http, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json) {
  'use strict';
  //region block: imports
  var serialization = kotlin_io_ktor_ktor_serialization_kotlinx.$_$.a;
  var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.h;
  var Unit_getInstance = kotlin_kotlin.$_$.k4;
  var Json$default = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  //endregion
  //region block: pre-declaration
  //endregion
  function get_DefaultJson() {
    init_properties_JsonSupport_kt_xg0arx();
    return DefaultJson;
  }
  var DefaultJson;
  function json(_this__u8e3s4, json, contentType) {
    init_properties_JsonSupport_kt_xg0arx();
    serialization(_this__u8e3s4, contentType, json);
  }
  function json$default(_this__u8e3s4, json_0, contentType, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      json_0 = get_DefaultJson();
    if (!(($mask0 & 2) === 0))
      contentType = Application_getInstance().i1y_1;
    return json(_this__u8e3s4, json_0, contentType);
  }
  function DefaultJson$lambda($this$Json) {
    init_properties_JsonSupport_kt_xg0arx();
    $this$Json.v2x_1 = true;
    $this$Json.y2x_1 = true;
    $this$Json.f2y_1 = true;
    $this$Json.z2x_1 = true;
    $this$Json.a2y_1 = false;
    $this$Json.d2y_1 = false;
    return Unit_getInstance();
  }
  var properties_initialized_JsonSupport_kt_9cgd93;
  function init_properties_JsonSupport_kt_xg0arx() {
    if (properties_initialized_JsonSupport_kt_9cgd93) {
    } else {
      properties_initialized_JsonSupport_kt_9cgd93 = true;
      DefaultJson = Json$default(null, DefaultJson$lambda, 1, null);
    }
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = json$default;
  //endregion
  return _;
}(module.exports, require('./ktor-ktor-serialization-kotlinx-js-ir.js'), require('./ktor-ktor-http-js-ir.js'), require('./kotlin-kotlin-stdlib-js-ir.js'), require('./kotlinx-serialization-kotlinx-serialization-json-js-ir.js')));

